interface DialogButton {
  label: string;
  color: string;
  onClick?: () => void;
}
export class ShareDataService {
  public isLoading = false;
  public isShowDialog = false;
  public dialogMessage = "";
  public dialogTitle = "";
  public dialogButtons?: DialogButton[];

  public showLoading() {
    this.isLoading = true;
  }

  public hideLoading() {
    this.isLoading = false;
  }

  public showDialog(
    title: string,
    message: string,
    dialogButtons?: DialogButton[],
  ) {
    this.dialogMessage = message;
    this.dialogTitle = title;
    this.isShowDialog = true;
    this.dialogButtons = dialogButtons;
  }

  public hideDialog(onClick?: () => void) {
    this.isShowDialog = false;
    this.dialogMessage = "";
    this.dialogTitle = "";
    this.dialogButtons = undefined;
    onClick?.();
  }
}

export const shareDataService = new ShareDataService();
